import { jsx as m } from "@emotion/react/jsx-runtime";
import { RowContainer as n } from "./Row.styled.js";
const f = ({
  borderColor: o,
  backgroundColor: r,
  as: t = "li",
  children: i
}) => /* @__PURE__ */ m(n, { as: t, borderColor: o, backgroundColor: r, children: i });
export {
  f as Row
};
